const config = {
  secret_key: "3da97680654f0b65b96dba92f29654a775873a5d626038764c937d308ecda422",
  crypto_key: "kzv6gdl7cu7pyzlvxgufkjq6xd5eci92",
  iv_key: "y0n3qyyh5jzgm7ug"
};

export default config;